import { EnvironmentVariable } from '@/global/constant/Environment';
export const API = {
  URL: EnvironmentVariable.baseUrl || 'http://localhost:3010',
  VERSION: `v${EnvironmentVariable.version}` || 'v1'
};
